import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import PageLayout from "common/LayoutContainers/PageLayout";
import styles from "./styles";
import curved14 from "assets/images/login-bg.jpg";

function CoverLayout({ header = "", children }) {
  const classes = styles({ image: curved14 });

  return (
    <PageLayout background="white">
      <Grid container className={classes.coverLayout}>
        <Grid item xs={11} sm={8} md={5} xl={5}>
          <SuiBox className={classes.formContainer}>
            {header}
            {children}
          </SuiBox>
        </Grid>
        <Grid item xs={12} md={7}>
          <SuiBox display={{ xs: "none", md: "block" }} className={classes.coverLayout_imageBox}>
            <SuiBox className={classes.coverLayout_image}>
              <SuiBox className={classes.titleContainer}>
                <SuiTypography
                  variant="h1"
                  fontWeight="light"
                  textTransform="none"
                  className={classes.mainTitle}
                >
                  Tu Plataforma
                </SuiTypography>
                <SuiTypography
                  variant="h2"
                  fontWeight="light"
                  textTransform="none"
                  className={classes.subtitle}
                >
                  aliada en&nbsp;
                  <SuiTypography
                    variant="h2"
                    component="span"
                    fontWeight="medium"
                    textTransform="none"
                  >
                    insolvencias
                  </SuiTypography>
                </SuiTypography>
                <SuiTypography
                  variant="h2"
                  fontWeight="light"
                  textTransform="none"
                  className={classes.subtitle}
                >
                  <SuiTypography
                    variant="h2"
                    component="span"
                    fontWeight="medium"
                    textTransform="none"
                  >
                    conciliaciones
                  </SuiTypography>
                  &nbsp;y más
                </SuiTypography>
                <SuiTypography
                  variant="h2"
                  fontWeight="light"
                  textTransform="none"
                  className={classes.subtitle}
                >
                  tipos de procesos
                </SuiTypography>
              </SuiBox>
            </SuiBox>
          </SuiBox>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

CoverLayout.propTypes = {
  header: PropTypes.node,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
